import { useState } from "react";
import Firebase from "./context/firebase";
import UnderConstruction from "./pages/UnderConstruction";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ThankYou from "./pages/ThankYou";
//Imports for AZ.com Logo

const router = createBrowserRouter([
  {
    path: "/",
    element: <UnderConstruction />,
  },
  {
    path: "/thankyou",
    element: <ThankYou />,
  },
]);

function App() {
  return (
    <Firebase>
      <RouterProvider router={router} />
    </Firebase>
  );
}

export default App;
